module.exports = __webpack_public_path__ + "static/img/can-cherry.bcba7fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cans/can-cherry.png
// module id = ybhJ
// module chunks = 0